module.exports = __webpack_public_path__ + "img/wallpaper.78b1d9f4.png";